import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '../..';
import { MenuItem } from 'src/components/Navbar/types';

const initialState: { menu: MenuItem[] | null } = {
  menu: null,
};

export const menuSlice = createSlice({
  name: 'menus/menu',
  initialState,
  reducers: {
    setMenu: (state, action) => {
      state.menu = action.payload;
    },
  },
});

export const menuSelector = (state: RootState) => state.menu;
export const { setMenu } = menuSlice.actions;
